import React from 'react';
import clsx from 'clsx';
import {
    makeStyles, AppBar, Toolbar, Typography, Hidden, NativeSelect
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import TranslateIcon from '@material-ui/icons/Translate';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import InputBase from '@material-ui/core/InputBase';
import customAxios from "../API/customAxios";
import { useIntl } from 'react-intl';
import { useHistory } from "react-router-dom";
import { pxToRem, breakpoints } from '../UIComponent/CommonStyle'

const MyNativeSelect = withStyles({
    icon: {
        color: "#fff"
    }
})(NativeSelect);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        color: '#fff',
        borderRadius: 4,
        position: 'relative',
        fontSize: pxToRem(16),
        [breakpoints.up("md")]: {
            fontSize: pxToRem(18),
        },
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    companyLogo: {
        height: pxToRem(30),
        [breakpoints.up("md")]: {
            height: pxToRem(42),
        }
    },
    toolbar: {
        paddingRight: 24,
    },
    appBar: {
        backgroundColor: '#232F3E',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        fontSize: pxToRem(15),
        [breakpoints.up("md")]: {
            fontSize: pxToRem(18),
        },
        flexGrow: 1,
        padding: '0 10px'
    },
    transateIcon: {
        fontSize: pxToRem(20),
        [breakpoints.up("md")]: {
            fontSize: pxToRem(26),
        },
        marginRight: 10
    },
    changeLangText: {
        marginRight: 20,
    },
    changeLangOptionText: {
        color: '#000'
    },
    userNameText: {
        fontSize: pxToRem(15),
        [breakpoints.up("md")]: {
            fontSize: pxToRem(18),
        },
        marginRight: 10,
    },
    accountIcon: {
        fontSize: pxToRem(20),
        [breakpoints.up("md")]: {
            fontSize: pxToRem(26),
        },
    },
}));

export default function Bar({ handleDrawerOpen }) {
    const intl = useIntl();
    const classes = useStyles();
    const [employeeName, setEmployeeName] = React.useState('');
    const [language, setLanguage] = React.useState(localStorage.getItem('locale'));
    const history = useHistory();

    const handleChange = (event) => {
        setLanguage(event.target.value);
        localStorage.setItem('locale', event.target.value);
        // reload the page
        history.go(0);
    };

    React.useEffect(() => {
        let isMounted = true;

        async function fetchData() {
            try {
                let staffDuty = localStorage.getItem('staff_duty');
                let employeeName = localStorage.getItem('employee_name');
                let departmentId = localStorage.getItem('department_id');

                if (staffDuty === null || employeeName === null) {
                    const userDataResponse = await customAxios.get('/get_user_data');
                    staffDuty = userDataResponse.data.staff_duty || '';
                    employeeName = userDataResponse.data.employee_name || '';
                    departmentId = userDataResponse?.data?.department_id || '';

                    if (isMounted) {
                        localStorage.setItem('staff_duty', staffDuty);
                        localStorage.setItem('employee_name', employeeName);
                        localStorage.setItem('department_id', departmentId);
                        setEmployeeName(employeeName);
                    }
                } else if (isMounted) {
                    setEmployeeName(employeeName);
                }

            } catch (error) {
                console.log('Error fetching user data and permission:', error);
            }
        }
        fetchData();

        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <React.Fragment>
            <AppBar position="absolute" className={clsx(classes.appBar)}>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <img src="/images/Logo_of_SUNeVision.png" className={classes.companyLogo} />
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        {process.env.REACT_APP_TITLE}
                    </Typography>
                    <Hidden xsDown>
                        <TranslateIcon className={classes.transateIcon} />
                        <MyNativeSelect
                            className={classes.changeLangText}
                            id="language-select-native"
                            value={language}
                            onChange={handleChange}
                            input={<BootstrapInput />}
                        >
                            <option value={'en'} className={classes.changeLangOptionText}>{intl.formatMessage({ id: 'bar.english' })}</option>
                            <option value={'zh'} className={classes.changeLangOptionText}>{intl.formatMessage({ id: 'bar.chinese' })}</option>
                        </MyNativeSelect>
                    </Hidden>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.userNameText}>
                        {employeeName || localStorage.getItem('employee_name')}
                    </Typography>
                    <AccountCircleIcon className={classes.accountIcon} />
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
}
